import Sidebar from 'src/components/ui/sidebar';
import { RequestsTable } from './RequestsTable/RequestsTable';

export const RequestsPage = () => {
  return (
    <Sidebar>
      <RequestsTable />
    </Sidebar>
  );
};
